import { configureStore } from "@reduxjs/toolkit";
import roleSlices from "../slices/roleSlices";

const store = configureStore({
  reducer: {
    roles: roleSlices,
  },
});
export default store;
